<a class="nav-link" matRipple *ngIf="item.visible">
    <span class="nav-link-title" [translate]="item.translate">{{item.title}}</span>
    <span class="nav-link-badge" *ngIf="item.badge" [translate]="item.badge.translate"
          [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
    </span>
    <mat-icon class="collapsable-arrow">keyboard_arrow_right</mat-icon>
</a>

<div class="children" [ngClass]="{'open': isOpen}">

        <ng-container *ngFor="let item of item.children">
            <pulse-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></pulse-nav-horizontal-item>
            <pulse-nav-horizontal-collapse *ngIf="item.type=='group'" [item]="item"></pulse-nav-horizontal-collapse>
        </ng-container>

</div>
